import Vue from 'vue'
import Meta from 'vue-meta'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Kone from '../views/Kone'
import Rules from '@/views/Rules'
import Result from '@/views/Result'
import { i18n } from '@/main'
import { getLanguage } from '@/utils'
import store from '@/store'

Vue.use(VueRouter)
Vue.use(Meta)

const routes = [
  {
    path: '/:locale',
    component: {
      template: '<router-view></router-view>'
    },
    beforeEnter: (to, from, next) => {
      const locale = to.params.locale
      const supportedLocales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
      if (!supportedLocales.includes((locale))) return next('fi')
      if (store.state.language !== locale) {
        i18n.locale = locale
        store.commit('language', { language: locale })
        console.debug('Router: ' + i18n.locale)
      }
      return next()
    },
    children: [
      {
        path: '',
        name: 'home',
        component: Home
      },
      {
        path: 'kone',
        name: 'kone',
        component: Kone
      },
      {
        path: 'rules',
        name: 'rules',
        component: Rules
      },
      {
        path: 'kone/:tulos',
        name: 'result',
        component: Result
      }
    ]
  },
  {
    path: '*',
    redirect () {
      return getLanguage()
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
